import { apolloCartClient, createSessionToken } from '../../Apollo/ApolloClient'
import { getCurrentSite } from '@strata-monorepo/utils/_SiteConfig'
import type { CohesionGlobal } from '@strata-monorepo/shared-types/src/window'
import type { TokenStrategy } from './TokenStrategy'

/**
 * Strategy for creating session tokens with Cohesion data
 */
export const sessionTokenStrategy: TokenStrategy = {
  createToken: async () => {
    const cohesion: CohesionGlobal | undefined = window._Cohesion
    const fullSiteName = getCurrentSite({ useNewSite: true })

    await createSessionToken({
      cohesionData: {
        anonymousId: cohesion?.anonymousId ?? '',
        sessionId: cohesion?.sessionId ?? '',
        instanceId: cohesion?.instanceId ?? '',
        tenantId: cohesion?.tenantId ?? '',
        writeKey: cohesion?.writeKey ?? '',
        userAgent: (cohesion?.webContext?.userAgent as string) ?? '',
      },
      site: fullSiteName,
    })
  },
  apolloClient: apolloCartClient,
  retryMetricName: 'strata.createSessionToken.retries',
  errorMetricName: 'strata.createSessionToken.error',
  modeName: 'session',
}
